<template>
    <el-card>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
                >Panel</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db+'/plugins/avisos' }">Avisos</el-breadcrumb-item> <el-breadcrumb-item>Items</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <div
            class="loading"
            v-loading="true"
            v-if="fecthItems.length === 0"
        ></div>
        <template v-else>
             <el-button type="primary" size="medium"  @click="$router.push('/dashboard/' + $route.params.db+'/plugins/avisos')">
                <i class="el-icon-back"></i> Atras
            </el-button><br><br>
            <app-table-paginate
                :routeEdit="routeEdit"
                :tableQuery="fecthItems"
                :tableColumns="tableColumns"
                :preview="preview"
                :limit="limit"
                :draggable="false"
                :search="true"
                :selection="'no'"

            ></app-table-paginate>
            <br />
            <br />
            <br />

        </template>
    </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";
import moment from "moment-timezone";

export default {
    name: "NotificacionesList",
    components: {
        "app-table-paginate": tablaConPaginador,
        "app-modal-draggable": Draggable
    },
    async created() {
       /* this.routeEdit =
            "/dashboard/" +
            this.$route.params.db +
            "/plugins/avisos/edit/";
            */
        this.init();
        this.$root.$on("delete", (id) => {

            this.eliminarRegistro(id);
        });
         this.$root.$on("customBtn", id => {
            console.log(id);
        });
    },

    data() {
        return {
            tableColumns: [
                {
                    prop: "id",
                    label: "#"
                },
                {
                    prop: "usuario",
                    label: "Usuario"
                },
 {
                    prop: "nombre",
                    label: "Item"
                },
                {
                    prop: "fecha_envio",
                    label: "Fecha"

                },
                {
                    prop: "numero_avisos",
                    label: "NºAvisos"

                },
                {
                    prop: "estado",
                    label: "Estado"

                }

            ],
            tableQuery: {},
            searchQuery: "",
            routeEdit: null,
            routeDelete: 'no',
            preview: null,
            templates: false,
            modalDraggable: false,
            limit: 50,
            access: []
        };
    },
    watch: {
        $route(to) {
          /*  this.routeEdit =
                "/dashboard/" +
                this.$route.params.db +
                "/plugins/avisos/" +
                this.$route.params.table +
                "/";
                */
            this.init();
        }
    },
    methods: {
        async init() {
            await this.getPages();
        },
        nuevoRegistro() {
            this.$router.push(
                "/dashboard/" +
                    this.$route.params.db +
                    "/plugins/avisos/new"
            );
        },

        async getPages() {
            this.tableQuery = [];
            const a = await ApiService.post("dashboard/plugin/avisos/envios/get", {
                id: this.$route.params.id,
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table")
            });
            if (a.data != "Algo ha fallado") {
                a.data.forEach(element => {
                    this.tableQuery.push(element);
                });
            } else {
                this.tableQuery = {};
            }
        },
        async eliminarRegistro(id) {
console.log(id);
            await ApiService.post("dashboard/delete", {
                 table: 'plugin_avisos_instancia_list',
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table"),
                id: id
            }).then(response => {
                this.deleterow = response.data;

                if (this.deleterow == 1) {
                    this.$message({
                        type: "success",
                        message: "Se ha eliminado correctamente"
                    });
                    this.getPages();
                } else {
                    this.$message({
                        type: "warning",
                        message: this.deleterow
                    });
                }
            });
        },
        showDraggable() {
            this.modalDraggable = true;
        },
        closeModal() {
            this.modalDraggable = false;
            this.init();
        }
    },
    computed: {
        fecthItems() {
            return this.tableQuery;
        },
        ...mapGetters(["userAccessPlugins"])
    }
};
</script>
<style >
.el-table_1_column_1  .cell {
    /*display: none !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/plugins/avisos/envios_list.vue